module.exports = __webpack_public_path__ + "img/SPA-img-02.13235235.jpg";